
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides-serp",
      function () {
        return require("private-next-pages/guides-serp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides-serp"])
      });
    }
  